/**
 * GiftTiers — first purchase + product-linked free gifts (theme copy)
 * Debug logs: ?gifttiers_debug=1 or localStorage.gifttiers_debug = "1"
 */
(function GiftTiersExtraGifts() {
  "use strict";

  var DEBUG = false;
  try {
    DEBUG =
      /(?:\?|&)gifttiers_debug=1(?:&|$)/.test(String(location.search || "")) ||
      window.localStorage.getItem("gifttiers_debug") === "1";
  } catch (_) {}

  // Theme owns this file — mark boot so a late app-block copy also exits.
  if (window.__GiftTiersExtraGiftsFullBooted) {
    if (DEBUG) console.info("[GiftTiers extra-gifts] full build already booted, skip");
    return;
  }
  window.__GiftTiersExtraGiftsFullBooted = true;
  window.__GiftTiersExtraGiftsBooted = true;
  window.__GiftTiersThemeOwnsExtraGifts = true;

  var LOG = "[GiftTiers extra-gifts]";

  function log() {
    if (!DEBUG) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(LOG);
      console.info.apply(console, args);
    } catch (_) { }
  }

  function warn() {
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(LOG);
      console.warn.apply(console, args);
    } catch (_) { }
  }

  function endpoints() {
    var ctx = window.GiftTierContext || {};
    return {
      fp: ctx.firstPurchaseEndpoint || "/apps/gifttiers/first-purchase-check",
      pg: ctx.productGiftEndpoint || "/apps/gifttiers/product-gift-check",
      loy: ctx.loyaltyGiftEndpoint || "/apps/gifttiers/loyalty-gift-check",
    };
  }

  var timer = null;
  var processing = false;
  var runId = 0;

  function normalizeId(id) {
    if (id == null) return "";
    var s = String(id);
    var m = s.match(/\/(\d+)$/);
    return m ? m[1] : s.trim();
  }

  function isGift(props) {
    if (!props) return false;
    var v = props._is_gift || props.is_gift;
    return v === true || v === "true" || v === "1" || v === 1;
  }

  function isFirstPurchaseGift(props) {
    return (
      isGift(props) &&
      (props._gift_first_purchase === "true" || props._gift_first_purchase === true)
    );
  }

  function isProductGift(props) {
    return isGift(props) && !!props._gift_product_offer_id;
  }

  function isLoyaltyGift(props) {
    return isGift(props) && !!props._gift_loyalty_offer_id;
  }

  /** Variants already gifted by first-purchase or product-gift (not loyalty). */
  function nonLoyaltyGiftVariantIds(cart) {
    var set = {};
    (cart.items || []).forEach(function (item) {
      if (!isGift(item.properties)) return;
      if (isLoyaltyGift(item.properties)) return;
      set[normalizeId(item.variant_id)] = true;
    });
    return set;
  }

  /** Prefer loyalty in B2B claim mode; otherwise FP > product > loyalty. */
  function giftProgramRank(props) {
    var manual = !!(getContext().manualGiftClaim);
    if (manual) {
      if (isLoyaltyGift(props)) return 4;
      if (isProductGift(props)) return 3;
      if (isFirstPurchaseGift(props)) return 2;
      return 1; // tier / generic gift
    }
    if (isFirstPurchaseGift(props)) return 3;
    if (isProductGift(props)) return 2;
    if (isLoyaltyGift(props)) return 1;
    return 0;
  }

  function extractNumericId(gid) {
    return normalizeId(gid);
  }

  function fetchCart() {
    log("fetchCart…");
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then(
      function (r) {
        if (!r.ok) throw new Error("cart " + r.status);
        return r.json();
      }
    );
  }

  function persistB2bDiscountAttrs(ctx) {
    // NEVER touch /cart/update.js in B2B claim mode — it breaks WSAIO drawer prices
    // (the main sales funnel). Threshold math uses GiftTierContext in JS instead.
    if (ctx && ctx.manualGiftClaim) return Promise.resolve();
    if (window.__GiftTiersB2bAttrsPersisted) return Promise.resolve();
    var pct =
      window.GiftTiersCartValue &&
        typeof window.GiftTiersCartValue.getB2bDiscountPercent === "function"
        ? window.GiftTiersCartValue.getB2bDiscountPercent(ctx)
        : Number(ctx.b2bDiscountPercent || 0) || 0;
    var tags = Array.isArray(ctx.customerTags) ? ctx.customerTags : [];
    window.__GiftTiersB2bAttrsPersisted = true;
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        attributes: {
          _gifttiers_b2b_discount_percent: pct > 0 ? String(pct) : "",
          _gifttiers_customer_tags: tags.slice(0, 50).join(","),
        },
      }),
    }).catch(function () {
      return null;
    });
  }

  /** One /cart/add.js for N gift lines — avoids cart re-renders between products. */
  function addGiftsBatch(lines) {
    if (!lines || !lines.length) return Promise.resolve(null);
    if (getContext().manualGiftClaim && !window.__GiftTiersClaimAddLock) {
      log("addGiftsBatch BLOCKED (manual claim — use Reclamar regalo)");
      return Promise.resolve(null);
    }
    var items = [];
    lines.forEach(function (line) {
      var id = extractNumericId(line.variantId);
      if (!id) return;
      items.push({
        id: Number(id),
        quantity: Math.max(1, line.quantity || 1),
        properties: line.properties || {},
      });
    });
    if (!items.length) {
      return Promise.reject(new Error("bad variants in batch"));
    }
    var payload = { items: items };
    log("cart/add.js (batch " + items.length + ") →", payload);
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) {
          warn("cart/add.js FAILED", r.status, body);
          throw new Error(
            (body && (body.description || body.message)) || "add failed " + r.status
          );
        }
        log("cart/add.js OK", body);
        return body;
      });
    });
  }

  function addGift(variantId, properties, quantity) {
    return addGiftsBatch([
      { variantId: variantId, properties: properties, quantity: quantity },
    ]);
  }

  function changeLine(key, quantity) {
    log("cart/change.js →", { key: key, quantity: quantity });
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      if (!r.ok) throw new Error("change failed " + r.status);
      return r.json();
    });
  }

  function removeLine(key) {
    return changeLine(key, 0);
  }

  function getContext() {
    var ctx = window.GiftTierContext || {};
    return {
      loggedIn: Boolean(ctx.loggedIn),
      ordersCount: Number(ctx.ordersCount || 0),
      customerId: ctx.customerId != null ? String(ctx.customerId) : null,
      customerTags: Array.isArray(ctx.customerTags) ? ctx.customerTags : [],
      shop:
        ctx.shop ||
        (window.Shopify && window.Shopify.shop) ||
        "",
    };
  }

  function notifyCartUpdated() {
    log("dispatch cart:refresh / cart:updated");
    var detail = { source: "gifttiers-extra-gifts" };
    ["cart:updated", "theme:cart:updated", "cart:refresh"].forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
      } catch (_) { }
    });
    ["cart:refresh", "cart:updated"].forEach(function (name) {
      try {
        window.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
      } catch (_) { }
    });
  }

  function fpLineKey(offerId, variantId) {
    return String(offerId) + "|" + normalizeId(variantId);
  }

  function reconcileFirstPurchase(cart) {
    var ctx = getContext();
    var existingByKey = {};
    var orphanFpLines = [];

    (cart.items || []).forEach(function (item) {
      if (!isFirstPurchaseGift(item.properties)) return;
      var oid = String((item.properties && item.properties._gift_offer_id) || "");
      if (oid) existingByKey[fpLineKey(oid, item.variant_id)] = item;
      else orphanFpLines.push(item);
    });

    log("FP reconcile start", {
      loggedIn: ctx.loggedIn,
      ordersCount: ctx.ordersCount,
      shop: ctx.shop,
      existingKeys: Object.keys(existingByKey),
      orphans: orphanFpLines.length,
      cartItemCount: (cart.items || []).length,
    });

    if (!ctx.loggedIn) {
      log("FP skip — guest (not logged in)");
      var leftovers = (cart.items || []).filter(function (item) {
        return isFirstPurchaseGift(item.properties);
      });
      if (!leftovers.length) return Promise.resolve(false);
      var wipe = Promise.resolve();
      leftovers.forEach(function (line) {
        wipe = wipe.then(function () {
          return removeLine(line.key);
        });
      });
      return wipe.then(function () {
        return true;
      });
    }

    if (ctx.ordersCount > 0) {
      log("FP skip — ordersCount > 0 (not first purchase)", ctx.ordersCount);
    }

    var regularTotal =
      window.GiftTiersCartValue && typeof window.GiftTiersCartValue.regularCartValue === "function"
        ? window.GiftTiersCartValue.regularCartValue(cart, {
          isGift: isGift,
          context: ctx,
        })
        : (cart.items || [])
          .filter(function (i) {
            return !isGift(i.properties);
          })
          .reduce(function (s, i) {
            var cents =
              Number(i.final_line_price) >= 0 &&
                Number(i.final_line_price) < Number(i.line_price)
                ? Number(i.final_line_price)
                : Number(i.line_price || 0);
            return s + cents;
          }, 0) / 100;

    var ep = endpoints().fp;
    var reqBody = {
      shop: ctx.shop,
      loggedIn: ctx.loggedIn,
      ordersCount: ctx.ordersCount,
      cartValue: regularTotal,
      customerTags: ctx.customerTags,
      b2bDiscountPercent:
        window.GiftTiersCartValue &&
          typeof window.GiftTiersCartValue.getB2bDiscountPercent === "function"
          ? window.GiftTiersCartValue.getB2bDiscountPercent(ctx)
          : Number(ctx.b2bDiscountPercent || 0) || 0,
    };
    log("FP API POST", ep, reqBody);

    return fetch(ep, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shop-Domain": ctx.shop,
      },
      credentials: "same-origin",
      body: JSON.stringify(reqBody),
    })
      .then(function (r) {
        log("FP API status", r.status);
        if (!r.ok) throw new Error("fp-check " + r.status);
        return r.json();
      })
      .then(function (data) {
        log("FP API response", data);
        var desired = (data && data.gifts) || [];
        if ((!desired || !desired.length) && data && data.action) {
          if (data.action.type === "ADD" || data.action.type === "KEEP") {
            desired = [
              {
                offerId: data.action.offerId,
                giftVariantId: data.action.giftVariantId,
                quantity: data.action.quantity,
                minCartValue: data.action.minCartValue,
                maxUsesPerOrder: data.action.maxUsesPerOrder,
              },
            ];
          }
        }

        if (!desired.length) {
          log("FP no gifts desired (API empty / not eligible)");
        }

        var desiredByKey = {};
        desired.forEach(function (g) {
          desiredByKey[fpLineKey(g.offerId, g.giftVariantId)] = g;
        });

        var changed = false;
        var chain = Promise.resolve();

        orphanFpLines.forEach(function (line) {
          chain = chain.then(function () {
            log("FP remove orphan line", line.key);
            changed = true;
            return removeLine(line.key);
          });
        });

        Object.keys(existingByKey).forEach(function (key) {
          if (!desiredByKey[key]) {
            var line = existingByKey[key];
            chain = chain.then(function () {
              log("FP remove obsolete pack line", key);
              changed = true;
              return removeLine(line.key);
            });
          }
        });

        var manualClaimFp = !!(getContext().manualGiftClaim);
        var toAdd = [];
        desired.forEach(function (g) {
          var oid = String(g.offerId);
          var key = fpLineKey(oid, g.giftVariantId);
          var existing = existingByKey[key];
          var qty = Math.max(1, Number(g.quantity || g.maxUsesPerOrder || 1));
          var props = {
            _is_gift: "true",
            _gift_first_purchase: "true",
            _gift_offer_id: oid,
            _gift_max_uses: String(qty),
          };
          if (g.minCartValue > 0) {
            props._gift_min_cart_value = Number(g.minCartValue).toFixed(2);
          }

          if (existing) {
            if (existing.quantity === qty) {
              log("FP KEEP", key, "qty", qty);
              return;
            }
            if (manualClaimFp) {
              log("FP KEEP (manual, no ADJUST)", key);
              return;
            }
            changed = true;
            chain = chain.then(function () {
              log("FP ADJUST qty", key, qty);
              return changeLine(existing.key, qty);
            });
            return;
          }
          if (manualClaimFp) {
            log("FP skip ADD (manual claim mode)", key);
            return;
          }
          toAdd.push({
            variantId: g.giftVariantId,
            properties: props,
            quantity: qty,
          });
        });

        return chain
          .then(function () {
            if (!toAdd.length) return null;
            changed = true;
            log("FP ADD batch", toAdd.length);
            return addGiftsBatch(toAdd);
          })
          .then(function () {
            log("FP done, changed=", changed);
            return changed;
          });
      });
  }

  function reconcileProductGifts(cart) {
    var ctx = getContext();
    var existingGifts = [];
    (cart.items || []).forEach(function (item) {
      if (isProductGift(item.properties)) {
        existingGifts.push({
          offerId: String(item.properties._gift_product_offer_id),
          quantity: item.quantity,
          key: item.key,
        });
      }
    });

    var cartItems = (cart.items || []).map(function (i) {
      return {
        productId: String(i.product_id),
        variantId: String(i.variant_id),
        quantity: i.quantity,
        isGift: isGift(i.properties),
      };
    });

    var ep = endpoints().pg;
    log("PG API POST", ep, { items: cartItems.length, existing: existingGifts.length });

    return fetch(ep, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shop-Domain": ctx.shop,
      },
      credentials: "same-origin",
      body: JSON.stringify({
        shop: ctx.shop,
        cartItems: cartItems,
        existingGifts: existingGifts.map(function (g) {
          return { offerId: g.offerId, quantity: g.quantity };
        }),
      }),
    })
      .then(function (r) {
        log("PG API status", r.status);
        if (!r.ok) throw new Error("pg-check " + r.status);
        return r.json();
      })
      .then(function (data) {
        log("PG API response", data);
        var actions = (data && data.actions) || [];
        var byOffer = {};
        existingGifts.forEach(function (g) {
          byOffer[g.offerId] = g;
        });

        var changed = false;
        var chain = Promise.resolve();
        actions.forEach(function (action) {
          chain = chain.then(function () {
            log("PG action", action);
            if (action.type === "REMOVE") {
              var ex = byOffer[action.offerId];
              if (!ex) return null;
              changed = true;
              return removeLine(ex.key);
            }
            if (action.type === "KEEP") return null;
            if (action.type === "ADJUST_QUANTITY") {
              var line = byOffer[action.offerId];
              if (!line) return null;
              changed = true;
              return changeLine(line.key, action.quantity);
            }
            if (action.type === "ADD") {
              var props = {
                _is_gift: "true",
                _gift_product_offer_id: String(action.offerId),
                _gift_max_uses: String(action.quantity || 1),
              };
              if (action.triggerProductIds && action.triggerProductIds[0]) {
                props._gift_trigger_product_id = String(action.triggerProductIds[0]);
              }
              var existing = byOffer[action.offerId];
              changed = true;
              if (existing) {
                return removeLine(existing.key).then(function () {
                  return addGift(action.giftVariantId, props, action.quantity);
                });
              }
              return addGift(action.giftVariantId, props, action.quantity);
            }
            return null;
          });
        });
        return chain.then(function () {
          log("PG done, changed=", changed);
          return changed;
        });
      });
  }

  function reconcileLoyaltyGifts(cart) {
    var ctx = getContext();
    var existingByVariant = {};
    (cart.items || []).forEach(function (item) {
      if (!isLoyaltyGift(item.properties)) return;
      existingByVariant[normalizeId(item.variant_id)] = item;
    });
    var existingCount = Object.keys(existingByVariant).length;

    log("Loyalty reconcile start", {
      loggedIn: ctx.loggedIn,
      customerId: ctx.customerId,
      shop: ctx.shop,
      existingLines: existingCount,
    });

    if (!ctx.customerId) {
      log("Loyalty skip — no known customer (guest)");
      var leftovers = (cart.items || []).filter(function (item) {
        return isLoyaltyGift(item.properties);
      });
      if (!leftovers.length) return Promise.resolve(false);
      var wipe = Promise.resolve();
      leftovers.forEach(function (line) {
        wipe = wipe.then(function () {
          return removeLine(line.key);
        });
      });
      return wipe.then(function () {
        return true;
      });
    }

    // Metafield gifttiers.loyalty_redeemed already set → never offer again.
    var redeemedRaw = String(window.GiftTierLoyaltyRedeemed || ctx.loyaltyRedeemed || "").trim();
    if (redeemedRaw) {
      log("Loyalty skip — already redeemed (metafield)", redeemedRaw);
      var usedLines = (cart.items || []).filter(function (item) {
        return isLoyaltyGift(item.properties);
      });
      if (!usedLines.length) return Promise.resolve(false);
      var wipeUsed = Promise.resolve();
      usedLines.forEach(function (line) {
        wipeUsed = wipeUsed.then(function () {
          return removeLine(line.key);
        });
      });
      return wipeUsed.then(function () {
        return true;
      });
    }

    var regularTotal =
      window.GiftTiersCartValue && typeof window.GiftTiersCartValue.regularCartValue === "function"
        ? window.GiftTiersCartValue.regularCartValue(cart, {
          isGift: isGift,
          context: ctx,
        })
        : (cart.items || [])
          .filter(function (i) {
            return !isGift(i.properties);
          })
          .reduce(function (s, i) {
            var cents =
              Number(i.final_line_price) >= 0 &&
                Number(i.final_line_price) < Number(i.line_price)
                ? Number(i.final_line_price)
                : Number(i.line_price || 0);
            return s + cents;
          }, 0) / 100;

    var ep = endpoints().loy;
    var reqBody = {
      shop: ctx.shop,
      customerId: ctx.customerId,
      cartValue: regularTotal,
      customerTags: ctx.customerTags,
      loyaltyRedeemed: String(window.GiftTierLoyaltyRedeemed || ctx.loyaltyRedeemed || ""),
      b2bDiscountPercent:
        window.GiftTiersCartValue &&
          typeof window.GiftTiersCartValue.getB2bDiscountPercent === "function"
          ? window.GiftTiersCartValue.getB2bDiscountPercent(ctx)
          : Number(ctx.b2bDiscountPercent || 0) || 0,
    };
    log("Loyalty API POST", ep, reqBody);

    return fetch(ep, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shop-Domain": ctx.shop,
      },
      credentials: "same-origin",
      body: JSON.stringify(reqBody),
    })
      .then(function (r) {
        log("Loyalty API status", r.status);
        if (!r.ok) throw new Error("loyalty-check " + r.status);
        return r.json();
      })
      .then(function (data) {
        log("Loyalty API response", data);
        var offerId = data && data.offerId ? String(data.offerId) : null;
        var items = (data && data.items) || [];
        // Same variant already gifted by first-purchase / product-gift → do not stack.
        var blockedVariants = nonLoyaltyGiftVariantIds(cart);
        if (Object.keys(blockedVariants).length) {
          log("Loyalty blocked variants (FP/PG)", Object.keys(blockedVariants));
        }

        var desiredByVariant = {};
        items.forEach(function (it) {
          var vid = normalizeId(it.giftVariantId);
          if (blockedVariants[vid]) {
            log("Loyalty SKIP desired item — already gifted", vid);
            return;
          }
          desiredByVariant[vid] = it;
        });

        var changed = false;
        var chain = Promise.resolve();

        // Remove loyalty lines that conflict with FP/PG, or are no longer desired.
        Object.keys(existingByVariant).forEach(function (variantId) {
          if (!desiredByVariant[variantId] || blockedVariants[variantId]) {
            var line = existingByVariant[variantId];
            chain = chain.then(function () {
              log(
                blockedVariants[variantId]
                  ? "Loyalty remove conflict with FP/PG"
                  : "Loyalty remove obsolete line",
                variantId
              );
              changed = true;
              return removeLine(line.key);
            });
          }
        });

        if (!offerId) {
          log("Loyalty no bundle desired (API empty / not eligible)");
          return chain.then(function () {
            return changed;
          });
        }

        var manualClaim = !!(getContext().manualGiftClaim);
        if (manualClaim) {
          log("Loyalty manual claim mode — no auto ADD");
          Object.keys(desiredByVariant).forEach(function (variantId) {
            var existing = existingByVariant[variantId];
            if (existing) log("Loyalty KEEP (manual)", variantId, "qty", existing.quantity);
          });
          return chain.then(function () {
            log("Loyalty done (manual), changed=", changed);
            return changed;
          });
        }

        var toAdd = [];
        Object.keys(desiredByVariant).forEach(function (variantId) {
          var it = desiredByVariant[variantId];
          var existing = existingByVariant[variantId];
          var quantity = Math.max(1, Number(it.quantity || 1));
          var props = {
            _is_gift: "true",
            _gift_loyalty_offer_id: offerId,
            _gift_max_uses: String(quantity),
          };

          if (existing) {
            var existingOffer =
              existing.properties && existing.properties._gift_loyalty_offer_id
                ? String(existing.properties._gift_loyalty_offer_id)
                : "";
            if (
              existing.quantity === quantity &&
              existingOffer === String(offerId)
            ) {
              log("Loyalty KEEP", variantId, "qty", quantity);
              return;
            }
            changed = true;
            chain = chain.then(function () {
              log("Loyalty REPLACE", variantId, {
                fromOffer: existingOffer,
                toOffer: offerId,
                qty: quantity,
              });
              return removeLine(existing.key);
            });
            toAdd.push({
              variantId: it.giftVariantId,
              properties: props,
              quantity: quantity,
            });
            return;
          }
          toAdd.push({
            variantId: it.giftVariantId,
            properties: props,
            quantity: quantity,
          });
        });

        return chain
          .then(function () {
            if (!toAdd.length) return null;
            changed = true;
            log("Loyalty ADD batch", toAdd.length);
            return addGiftsBatch(toAdd);
          })
          .then(function () {
            log("Loyalty done, changed=", changed);
            return changed;
          });
      });
  }

  /**
   * Collapse gift lines of the same variant to ONE line.
   * Caps qty using _gift_max_uses when present (stops 20+20=40 stacks).
   */
  function dedupeConflictingGiftLines(cart) {
    var byVariant = {};
    (cart.items || []).forEach(function (item) {
      if (!isGift(item.properties)) return;
      var vid = normalizeId(item.variant_id);
      if (!byVariant[vid]) byVariant[vid] = [];
      byVariant[vid].push(item);
    });

    var changed = false;
    var chain = Promise.resolve();

    Object.keys(byVariant).forEach(function (vid) {
      var lines = byVariant[vid];
      lines.sort(function (a, b) {
        return giftProgramRank(b.properties) - giftProgramRank(a.properties);
      });
      var keep = lines[0];
      var cap = Number(
        (keep.properties && keep.properties._gift_max_uses) || 0
      );
      if (!(cap > 0)) {
        // Fallback: if stacked lines, keep the largest single-line qty (not the sum).
        cap = lines.reduce(function (m, l) {
          return Math.max(m, Number(l.quantity || 0));
        }, 1);
      }
      // Hard safety: never keep more than the highest single offer cap on stacked lines
      if (lines.length > 1) {
        var maxCap = lines.reduce(function (m, l) {
          var c = Number((l.properties && l.properties._gift_max_uses) || l.quantity || 0);
          return Math.max(m, c);
        }, 1);
        cap = Math.min(cap, maxCap);
      }

      for (var i = 1; i < lines.length; i++) {
        (function (line) {
          chain = chain.then(function () {
            warn("dedupe remove stacked gift", vid, line.key, line.properties);
            changed = true;
            return removeLine(line.key);
          });
        })(lines[i]);
      }

      if (keep.quantity !== cap) {
        chain = chain.then(function () {
          warn("dedupe cap gift qty", vid, keep.quantity, "→", cap);
          changed = true;
          return changeLine(keep.key, cap);
        });
      }
    });

    return chain.then(function () {
      return changed;
    });
  }

  /** Gift lines that still charge after CT — only strip stale/wrong loyalty offers. */
  function stripChargedGiftLines(cart) {
    var charged = (cart.items || []).filter(function (item) {
      if (!isGift(item.properties)) return false;
      var line = Number(item.final_line_price);
      if (!Number.isFinite(line)) line = Number(item.line_price);
      if (!(Number.isFinite(line) && line > 0)) return false;
      // Free gifts briefly still show list price in cart.js before CT settles —
      // only nuke loyalty lines that are clearly broken (no offer id).
      if (isLoyaltyGift(item.properties)) {
        var oid = item.properties._gift_loyalty_offer_id;
        return !oid;
      }
      return true;
    });
    if (!charged.length) return Promise.resolve(false);
    warn(
      "removing charged gift lines",
      charged.map(function (i) {
        return { title: i.product_title, line: i.line_price, props: i.properties };
      })
    );
    var chain = Promise.resolve();
    charged.forEach(function (line) {
      chain = chain.then(function () {
        return removeLine(line.key);
      });
    });
    return chain.then(function () {
      return true;
    });
  }

  function refresh() {
    if (processing) {
      log("refresh skipped (already processing)");
      return;
    }
    processing = true;
    var id = ++runId;
    log("═══ refresh #" + id + " start ═══");
    var anyChanged = false;
    var ctx = getContext();

    // B2B claim mode: ONLY collapse stacked gifts (fix 20+20=40). No auto-add APIs.
    if (ctx.manualGiftClaim) {
      fetchCart()
        .then(function (cart) {
          return dedupeConflictingGiftLines(cart);
        })
        .then(function (changed) {
          anyChanged = !!changed;
        })
        .catch(function (err) {
          warn("refresh error", err && err.message ? err.message : err);
        })
        .then(function () {
          processing = false;
          log("═══ refresh #" + id + " (manual dedupe) end, changed=", anyChanged, "═══");
          if (anyChanged) {
            try {
              document.dispatchEvent(
                new CustomEvent("cart:refresh", { detail: { source: "gifttiers-extra-gifts" } })
              );
            } catch (_) {}
          }
        });
      return;
    }

    persistB2bDiscountAttrs(ctx)
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        log("cart items", (cart.items || []).map(function (i) {
          return {
            id: i.variant_id,
            qty: i.quantity,
            title: i.product_title,
            props: i.properties,
            line_price: i.line_price,
          };
        }));
        return reconcileFirstPurchase(cart).then(function (changed) {
          if (changed) anyChanged = true;
          return fetchCart();
        });
      })
      .then(function (cart) {
        return reconcileProductGifts(cart).then(function (changed) {
          if (changed) anyChanged = true;
          return fetchCart();
        });
      })
      .then(function (cart) {
        return reconcileLoyaltyGifts(cart).then(function (changed) {
          if (changed) anyChanged = true;
          return fetchCart();
        });
      })
      .then(function (cart) {
        return dedupeConflictingGiftLines(cart).then(function (changed) {
          if (changed) anyChanged = true;
          return fetchCart();
        });
      })
      .then(function (cart) {
        return stripChargedGiftLines(cart).then(function (changed) {
          if (changed) anyChanged = true;
        });
      })
      .catch(function (err) {
        warn("refresh error", err && err.message ? err.message : err);
      })
      .then(function () {
        processing = false;
        log("═══ refresh #" + id + " end, changed=", anyChanged, "═══");
        if (anyChanged) notifyCartUpdated();
      });
  }

  function schedule(ms) {
    clearTimeout(timer);
    log("schedule refresh in", ms, "ms");
    timer = setTimeout(refresh, typeof ms === "number" ? ms : 250);
  }

  function boot() {
    var ctx = getContext();
    log("boot", {
      shop: ctx.shop,
      loggedIn: ctx.loggedIn,
      ordersCount: ctx.ordersCount,
      tags: ctx.customerTags,
      hasGiftTierContext: !!window.GiftTierContext,
      manualGiftClaim: !!ctx.manualGiftClaim,
    });
    // Manual claim mode: only collapse stacked gifts — claim UI owns adds.
    if (ctx.manualGiftClaim) {
      schedule(300);
      schedule(1500);
      [
        "cart-drawer:open",
        "line-item:change:end",
        "gifttiers:loyalty-claimed",
      ].forEach(function (evt) {
        document.addEventListener(evt, function () {
          schedule(200);
        });
      });
      return;
    }
    schedule(80);
    schedule(500);
    schedule(1500);
    schedule(3000);
    schedule(6000);
    [
      "cart-drawer:open",
      "cart:refresh",
      "cart:item-added",
      "line-item:change:end",
      "cart:updated",
      "theme:cart:updated",
    ].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (e && e.detail && e.detail.source === "gifttiers-extra-gifts") return;
        log("event →", evt);
        schedule(220);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
